import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { SubscribeNotificationSuccessfulPage } from "./subscribe-notification-successful";

@NgModule({
  declarations: [SubscribeNotificationSuccessfulPage],
  imports: [IonicPageModule.forChild(SubscribeNotificationSuccessfulPage)],
})
export class SubscribeNotificationSuccessfulPageModule {}



// WEBPACK FOOTER //
// ./src/pages/subscribe-notification-successful/subscribe-notification-successful.module.ts